import { MrpCosmosService } from "./modelResearchPageCosmos";
// Browser entry point (webpack bundle): instantiate and wire up the service.
// Kept separate from the class module so the class can be imported by tests
// without triggering DOM side effects at import time.
new MrpCosmosService().init();
